module.exports = __webpack_public_path__ + "static/media/Linh_RDA.1fe46bfe.png";